import { Auth0ClientOptions, createAuth0Client } from '@auth0/auth0-spa-js';

import type { AuthObject } from '@white-label-types/auth';
import { datadogRum } from '@datadog/browser-rum';

export const createAuthClientWrapper = async (
	authInstance: AuthObject,
	options: Auth0ClientOptions
) => {

	// setup auth0 client
	if (authInstance.clientId && authInstance.domain && authInstance.audience) {
		authInstance.auth0Client = await createAuth0Client(options);
	} else {
		const errorContext = {
			file: 'white-label-plugin > auth.ts > initAuth()',
			domain: authInstance.domain || '',
			clientId: authInstance.clientId || '',
			audience: authInstance.audience || '',
		}
		console.error('Datadog error logged - error during initAuth', errorContext)
		datadogRum.addError(
			new Error('Error during initAuth: options missing data'),
			errorContext
		);
	}

}
